module.exports = __webpack_public_path__ + "img/seo-content-collapsible-toyota.59afa822.png";